<template>
  <p :class="klass">
    <template v-if="percentage !== null && customer.subscription"
      ><span v-tooltip="tooltip">{{ percentage }}%</span><br /></template
    ><span v-if="customer.subscription">{{ customer.subscription.name }}</span>
  </p>
</template>
<script>
export default {
  props: ['customer'],
  data: function () {
    return {
      icon: null,
      klass: '',
      percentage: 0,
      prediction: 0
    };
  },
  mounted() {
    if (!this.customer.on_optimal_plan) {
      this.klass = 'text-danger';
    }

    if (!this.customer.usage_percent) {
      this.percentage = null;

      return;
    }

    this.prediction = this.customer.predicted_mrr_customer_currency;
    this.percentage = Math.floor(this.customer.usage_percent);

    if (!Number.isSafeInteger(this.percentage)) {
      this.percentage = 0;
    }
  },
  computed: {
    tooltip() {
      const currency = this.customer.subscription.currency;
      const price = Math.floor(this.customer.monthly_price);
      const plan = this.customer.subscription.name;

      return `${this.$i18n.t('prediction')}: ${this.prediction} ${currency}
          <br>
          ${this.$i18n.t('subscription')}: ${price} ${currency}
          <br>
          ${this.$i18n.t('plan')}: ${plan}
          `;
    }
  }
};
</script>
